import { useState } from 'react'
import axios from 'axios'

import { GetApiVehicleData } from '../interfaces/GetApiVehicleData'
import { GetApiVinData } from '../interfaces/GetApiVinData'
import { GetApiAppraisalData } from '../interfaces/GetApiAppraisalData'
import { api } from '../utils/api'

export const useGetApi = () => {
  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<string | null>(null)

  const fetchVehicleByPlate = async (plate: string): Promise<GetApiVehicleData | null> => {
    setLoading(true)
    setError(null)
    try {
      const response = await api.get(`/getapi/plate/${plate}`)

      if (response.data && response.data.data) {
        return response.data.data
      }

      return null
    } catch (err: unknown) {
      const errorMsg = axios.isAxiosError(err)
        ? err.response?.data?.error || err.message
        : 'Error al buscar, ingresar de manera manual'
      setError(errorMsg)

      return null
    } finally {
      setLoading(false)
    }
  }

  const decodeVin = async (vin: string): Promise<GetApiVinData | null> => {
    setLoading(true)
    setError(null)
    try {
      const response = await api.get(`/getapi/vin/${vin}`)

      if (response.data && response.data.data) {
        return response.data.data
      }

      return null
    } catch (err: unknown) {
      const errorMsg = axios.isAxiosError(err)
        ? err.response?.data?.error || err.message
        : 'error al decodificar vin, ingresar de manera manual'
      setError(errorMsg)

      return null
    } finally {
      setLoading(false)
    }
  }

  const getAppraisalByPlate = async (plate: string): Promise<GetApiAppraisalData | null> => {
    setLoading(true)
    setError(null)
    try {
      const response = await api.get(`/getapi/appraisal/${plate}`)

      if (response.data && response.data.data) {
        return response.data.data
      }

      return null
    } catch (err: unknown) {
      if (axios.isAxiosError(err) && err.response?.status === 404) {
        // 404 is expected for new cars or those without SII appraisal
        return null
      }
      const errorMsg = axios.isAxiosError(err)
        ? err.response?.data?.error || err.message
        : 'Error al obtener tasación, ingresar de manera manual'
      setError(errorMsg)

      return null
    } finally {
      setLoading(false)
    }
  }

  return { loading, error, fetchVehicleByPlate, decodeVin, getAppraisalByPlate }
}
